// ABOUTME: RTK Query API slice for shipping options endpoints.
// ABOUTME: Handles checkout-enabled shippers listing and per-webshop shipping option configuration.

import { apiSlice } from "../createApiSlice";

const SHIPPING_OPTIONS_BASE = "/shipping-options";
const buildUrl = (endpoint) => SHIPPING_OPTIONS_BASE + endpoint;
const ApiName = "ShippingOptions";

const shippingOptionsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCheckoutShippers: builder.query({
            query: () => ({
                url: buildUrl(`/shippers`),
                method: 'GET'
            }),
            providesTags: [{ type: ApiName, id: 'shippers' }],
        }),
        getWebshopShippingOptions: builder.query({
            query: (webshopCredentialId) => ({
                url: buildUrl(`/webshop/${webshopCredentialId}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: ApiName, id: `webshop-${arg}` }],
        }),
        saveWebshopShippingOptions: builder.mutation({
            query: ({ webshopCredentialId, shippingOptions }) => ({
                url: buildUrl(`/webshop/${webshopCredentialId}`),
                method: 'PUT',
                body: { shippingOptions },
            }),
            invalidatesTags: (result, error, arg) => [{ type: ApiName, id: `webshop-${arg.webshopCredentialId}` }],
        }),
    })
});

export const {
    useGetCheckoutShippersQuery,
    useGetWebshopShippingOptionsQuery,
    useSaveWebshopShippingOptionsMutation,
} = shippingOptionsApiSlice;
